import Blazy from 'blazy';

export default function () {
    function lazyLoad() {
        const bLazy = new Blazy({
            loadInvisible: false,
            offset: 500,
            breakpoints: [
                {
                    width: 640, 
                    src: 'data-src-small',
                },
                {
                    width: 1024, 
                    src: 'data-src-medium',
                },
            ],
        });
    
        bLazy.revalidate();
    
        const lazyLoadButtons = document.querySelectorAll('.js-lazyLoad');
    
        if(lazyLoadButtons.length > 0){
            lazyLoadButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    setTimeout(function () {
                        bLazy.revalidate();
                    }, 0);
                });
            });
        }
    
        const imagesToForceLoad = document.querySelectorAll('.js-force-b-lazy');
        if (imagesToForceLoad.length > 0) {
            bLazy.load(imagesToForceLoad, true);
        }
    }
    
    if (document.querySelectorAll('.b-lazy').length) {
        lazyLoad();
    
        if (document.readyState === 'complete') {
            lazyLoad();
        } else {
            window.addEventListener('load', function () {
                lazyLoad();
            });
        }
    }
    
}
// /*
// *   this function sets up b-lazy to lazy load our images!
// *   add the 'b-lazy' class and then set 'data-src-small',
// *   'data-src-medium' and 'data-src-large' for images to render
// *   at the breakpoints specified below
// */
// const Blazy = require('blazy');

// const bLazy = new Blazy({
//     loadInvisible: false,
//     offset: 500,
//     breakpoints: [
//         {
//             width: 640, // max-width
//             src: 'data-src-small',
//         },
//         {
//             width: 1024, // max-width
//             src: 'data-src-medium',
//         },
//     ],
// });

// function lazyLoad() {

//     bLazy.revalidate();

//     /*
//     *   additional helper function -> if you give a button the class
//     *   'js-lazyload', it will revalidate blazy when pressed
//     *   (useful for images that begin their life off screen, e.g. in carousels)
//     */
//     const lazyLoadButtons = document.getElementsByClassName('js-lazyLoad');

//     if (lazyLoadButtons.length) {

//         for (let i = 0; i < lazyLoadButtons.length; i++) {

//             lazyLoadButtons[i].addEventListener('click', function setTimeoutAndRevalidate() {

//                 setTimeout(function revalidateLazyLoad() {

//                     bLazy.revalidate();

//                 }, 0);

//             });

//         }

//     }

//     const imagesToForceLoad = document.getElementsByClassName('js-force-b-lazy');
//     if (imagesToForceLoad.length > 0) {

//         bLazy.load(imagesToForceLoad, true);

//     }

// }

// if (document.getElementsByClassName('b-lazy').length) {

//     lazyLoad();
//     if (document.readyState === 'complete') {

//         lazyLoad();

//     } else {

//         window.addEventListener('load', function lazyWindowLoad() {

//             lazyLoad();

//         }, 0);

//     }

// }
